import { AlertsState } from 'reducers/alerts/AlertsState';
import { createSelector } from 'reselect';
import { RootState } from 'store';
import { AlertScreen } from 'types/Alert';

export const getAlertsByScreen = createSelector(
    (state: RootState) => state.alerts,
    (_: RootState, screen: AlertScreen) => screen,
    (alerts: AlertsState, screen: AlertScreen) => {
        const uniqueAlerts = alerts.reduce((arr, alert) => {
            const alertExists = arr.find(item => item.text === alert.text);

            if (!alertExists && alert.screen === screen) {
                arr.push(alert);
            }

            return arr;
        }, [] as AlertsState);

        return uniqueAlerts;
    }
);
